import { Component, OnInit, OnDestroy } from '@angular/core';
import { AuthService } from '../auth/auth.service';
import { UsersService } from '../users/users.service';
import { User } from '../auth/user';
import { Router, ActivatedRoute } from '@angular/router';
import { Observable, Subscription } from 'rxjs';
import { DeviceDetectorService } from 'ngx-device-detector';
import { ReportService } from '../_services/report.service';
import { saveAs } from 'file-saver';
import { PermissionsService } from '../permissions.service';
import { DataService } from '../_services/data.service';
import * as moment from 'moment';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.scss'],
})
export class LayoutComponent implements OnInit, OnDestroy {
  isDesktopDevice;
  component;
  openedMenu = false;

  meSubscribe: Subscription;
  interval;

  constructor(
    private deviceService: DeviceDetectorService,
    public usersService: UsersService,
    private reportService: ReportService,
    private authService: AuthService,
    private router: Router,
    private route: ActivatedRoute,
    public permissionsService: PermissionsService,
    private _data: DataService
  ) {
    if (this.route.snapshot.queryParams.setToken) {
      sessionStorage.setItem(
        'userToken',
        JSON.stringify({ token: this.route.snapshot.queryParams.setToken })
      );
    }

    this.isDesktopDevice = this.deviceService.isDesktop();

    this.usersService.getMe();
    this.interval = setInterval(() => {
      this.usersService.getMe();
    }, 15000);

    this.meSubscribe = this.router.events.subscribe((event: any) => {
      this.openedMenu = false;
      if (event.url) {
        const items = event.url.split('/');
        if (items.length > 0) {
          this.component = items[1];
        }
      }
    });
  }

  year = new Date().getFullYear().toString();

  me$: Observable<any>;
  user: User;

  getReport(name, format?) {
    const filename = `${name}__${moment().format('YYYY-MM-DD_HH:mm')}`;

    this._data
      .invoke(`report/${name}/export?filename=${filename}`, 'get', null, null, {
        responseType: 'blob',
      })
      .subscribe(
        (res) => {
          if (format === 'csv') {
            const blobData: Blob = new Blob([res], {
              type: 'text/csv;charset=utf-8',
            });
            saveAs(blobData, `${filename}.csv`);
          } else {
            const blobData: Blob = new Blob([res], {
              type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
            });
            saveAs(blobData, `${filename}.xlsx`);
          }
        },
        (err) => {
          console.error(err);
        }
      );
  }

  ngOnInit() {
    this.usersService.me$.subscribe((me: any) => {
      if (me !== null) {
        this.user = {
          email: me.email,
          firstname: me.firstname,
          lastname: me.lastname,
          mobile: me.mobile,
          role: me.role,
          require_password_update: me.require_password_update,
          // messages: me.messages,
          system_messages: me.system_messages,
          website_permissions: me.website_permissions,
        };
      }
    });
  }

  ngOnDestroy(): void {
    this.meSubscribe.unsubscribe();
    clearInterval(this.interval);
  }

  redirectToChangePassword(userObj) {
    if (userObj && userObj.require_password_update === true) {
      this.router.navigate(['/profile/change-password'], {
        queryParams: { returnUrl: window.location.pathname },
      });
    }
  }

  logout() {
    sessionStorage.setItem('orientationInfoDisplay', '1');
    this._data.invoke('logout').subscribe((val) => {
      this.authService.logout();
      this.meSubscribe.unsubscribe();
      clearInterval(this.interval);
    });
  }
}
